import { render, staticRenderFns } from "./AdminsLiv2Table.vue?vue&type=template&id=6c364088&scoped=true&"
import script from "./AdminsLiv2Table.vue?vue&type=script&lang=ts&"
export * from "./AdminsLiv2Table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c364088",
  null
  
)

export default component.exports